import { render } from "./CategoryPage.vue?vue&type=template&id=1048682d"
import script from "./CategoryPage.vue?vue&type=script&lang=js"
export * from "./CategoryPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__